/**
 * LEGACY FIXED VALUES
 */

export const counters = [
    { text: 'Aucun', value: 0 },
    { text: 'Wifi', value: 1 },
    { text: 'Standard', value: 2 }
]

export const frequencyKeys = {
    QUOTIDIEN: 'quotidien',
    HEBDOMADAIRE: 'hebdomadaire',
    MENSUEL: 'mensuel',
}

export const frequencies = [
    { text: 'Quotidienne', value: frequencyKeys.QUOTIDIEN },
    { text: 'Hebdomadaire', value: frequencyKeys.HEBDOMADAIRE },
    { text: 'Mensuelle', value: frequencyKeys.MENSUEL }
]

export const segments = [
    'ACCESSORIES',
    'BOOKS, MUSIC & MULTIMEDIA',
    'CLOTHING-RELATED SERVICES',
    'DIY, GARDENING, ANIMALS',
    'ELECTRONICS AND HOUSEHOLD APPLIANCES',
    'EXCLUSIVE FASHION',
    'FAMILY FASHION',
    'FAST MEAL',
    'FLORISTS',
    'FOOTWEAR',
    'FURNITURE & INTERIOR DESIGN',
    'GOURMET FOOD PRODUCTS',
    'HAIR & BODY',
    'JEANSWEAR FASHION',
    'LEATH.BAGS/LUGGAGE',
    'LINGERIE & UNDERWEAR',
    'MATERN./CHILDREN FASHION',
    'MEDICAL OFFICE',
    'MEN\'S FASHION',
    'OPTICIAN',
    'OTHER PRODUCT-RELATED SERVICES',
    'PERFUMERY, BEAUTYCARE & PARAPHARMACY',
    'SERVICE TO TABLE RESTAURANTS',
    'SERVICES',
    'SPORT CLOTHES & EQUIPMENT',
    'THEMED GIFT',
    'TOYS',
    'WOMEN\'S FASHION'
]

export const days = [
    { text: 'Lundi', value: 1 },
    { text: 'Mardi', value: 2 },
    { text: 'Mercredi', value: 3 },
    { text: 'Jeudi', value: 4 },
    { text: 'Vendredi', value: 5 },
    { text: 'Samedi', value: 6 },
    { text: 'Dimanche', value: 0 }
]

export const countryKeys = {
  FRANCE: 'FRANCE',
  SUISSE: 'SUISSE',
};

export const countries = [
  { text: 'France', value: countryKeys.FRANCE },
  { text: 'Suisse', value: countryKeys.SUISSE },
];

export const taxByCountries = {
  reducedRate: {
    [countryKeys.FRANCE]: 5.5,
    [countryKeys.SUISSE]: 2.6,
    '': '-',
  },
  intermediateRate: {
    [countryKeys.FRANCE]: 10,
    [countryKeys.SUISSE]: 3.8,
    '': '-',
  },
  normalRate: {
    [countryKeys.FRANCE]: 20,
    [countryKeys.SUISSE]: 8.1,
    '': '-',
  },
}
